export enum AppModeTypes {
  FullScp = 'My SCP',
  StandaloneISM = 'My SCP Standalone ISM',
  BrochureShare = 'My SCP Brochure',
  StandaloneAreaMap = 'My SCP Standalone Area Map',
  StandaloneVisualizer = 'My SCP Standalone Visualizer',
  HomeConfigurator = 'Home Configurator'
}
